import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@plush-book/ui';

export function Review() {
  const { publicId } = useParams();
  const [approved, setApproved] = useState(false);
  const [showCorrection, setShowCorrection] = useState(false);

  return (
    <div className="shell">
      <div
        style={{
          padding: '14px 18px 12px',
          background: 'var(--bg-card)',
          borderBottom: '1px solid var(--line-soft)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <div
            style={{
              fontSize: 10,
              color: 'var(--ink-mute)',
              fontFamily: 'var(--mono)',
              letterSpacing: 1,
            }}
          >
            BUCH-VORSCHAU
          </div>
          <div style={{ fontFamily: 'var(--serif)', fontSize: 16, fontWeight: 600 }}>
            Buch {publicId}
          </div>
        </div>
        <span
          style={{
            padding: '3px 8px',
            background: 'var(--sage)',
            color: '#fff',
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 700,
          }}
        >
          BEREIT
        </span>
      </div>

      <div className="scroll" style={{ maxWidth: 760, margin: '0 auto', width: '100%' }}>
        <div style={{ fontSize: 13, color: 'var(--ink-soft)', marginBottom: 14, lineHeight: 1.5 }}>
          Prüfe alle 16 Seiten. Du kannst eine kostenlose Korrekturrunde anfragen.
        </div>

        <div
          style={{
            display: 'flex',
            gap: 4,
            padding: 8,
            background: 'var(--bg-card)',
            border: '1px solid var(--line)',
            borderRadius: 12,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              flex: 1,
              aspectRatio: '3/4',
              borderRadius: 4,
              background: 'linear-gradient(160deg, #2C3E54, #4D6781)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '45%',
                transform: 'translateX(-50%)',
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: 'linear-gradient(160deg, #C8916A, #8E5B3E)',
              }}
            />
          </div>
          <div
            style={{
              flex: 1,
              aspectRatio: '3/4',
              borderRadius: 4,
              background: 'var(--bg)',
              padding: 16,
              fontFamily: 'var(--serif)',
              fontSize: 12,
              lineHeight: 1.5,
              color: 'var(--ink)',
              position: 'relative',
            }}
          >
            <div style={{ fontStyle: 'italic' }}>
              Am Fenster funkelte ein kleiner Stern. Doch heute war sein Licht ganz schwach.
            </div>
          </div>
        </div>

        <div
          style={{
            fontSize: 11,
            color: 'var(--ink-mute)',
            fontFamily: 'var(--mono)',
            letterSpacing: 1,
            marginBottom: 8,
          }}
        >
          ALLE 16 SEITEN
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 6,
          }}
        >
          {Array.from({ length: 16 }).map((_, i) => {
            const styles = [
              'linear-gradient(160deg, #DCE7EE, #A8C0D2)',
              'var(--bg-card)',
              'linear-gradient(160deg, #2C3E54, #4D6781)',
              'var(--bg-card)',
              'linear-gradient(160deg, #DCE7EE, #A8C0D2)',
              'var(--bg-card)',
              'linear-gradient(160deg, #2C3E54, #4D6781)',
              'linear-gradient(160deg, #F4E5C4, #E0CC9D)',
            ];
            return (
              <div
                key={i}
                style={{
                  aspectRatio: '3/4',
                  borderRadius: 4,
                  background: styles[i % styles.length],
                  border: '1px solid var(--line)',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 3,
                    bottom: 3,
                    fontSize: 8,
                    color: 'rgba(44,36,24,0.6)',
                    fontFamily: 'var(--mono)',
                  }}
                >
                  {String(i + 1).padStart(2, '0')}
                </div>
              </div>
            );
          })}
        </div>

        <label
          style={{
            marginTop: 18,
            padding: 14,
            background: 'var(--bg-card)',
            border: '1.5px solid var(--terracotta)',
            borderRadius: 12,
            display: 'flex',
            gap: 10,
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={approved}
            onChange={(e) => setApproved(e.target.checked)}
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <div style={{ fontSize: 12, color: 'var(--ink-soft)', lineHeight: 1.5 }}>
            <span style={{ color: 'var(--terracotta-deep)', fontWeight: 700 }}>Pflicht ·</span> Ich
            habe die Vorschau geprüft und gebe mein personalisiertes Buch für den Druck frei. Nach
            der Freigabe sind keine Änderungen mehr möglich. Leichte Farbabweichungen zwischen
            Bildschirm und Druck können auftreten.
          </div>
        </label>

        {showCorrection && <CorrectionForm onCancel={() => setShowCorrection(false)} />}
      </div>

      <div
        className="sticky-cta"
        style={{ maxWidth: 760, margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}
      >
        <Button variant="sage" size="md" fullWidth disabled={!approved}>
          Für den Druck freigeben
        </Button>
        <button
          onClick={() => setShowCorrection((v) => !v)}
          style={{
            width: '100%',
            background: 'transparent',
            color: 'var(--ink-soft)',
            border: '1px solid var(--line)',
            padding: '12px',
            borderRadius: 14,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {showCorrection ? 'Korrektur abbrechen' : 'Korrektur anfragen'}
        </button>
      </div>
    </div>
  );
}

function CorrectionForm({ onCancel }: { onCancel: () => void }) {
  const [category, setCategory] = useState<string>('name_or_text');
  const [message, setMessage] = useState('');
  const categories = [
    { id: 'name_or_text', label: 'Name/Text korrigieren' },
    { id: 'plush_appearance', label: 'Kuscheltier sieht nicht richtig aus' },
    { id: 'image_error', label: 'Bildfehler auf einer Seite' },
    { id: 'dedication', label: 'Widmung ändern' },
    { id: 'other', label: 'Sonstiges' },
  ];
  return (
    <div
      style={{
        marginTop: 16,
        padding: 16,
        background: 'var(--bg-card)',
        border: '1px solid var(--line)',
        borderRadius: 14,
      }}
    >
      <div style={{ fontFamily: 'var(--serif)', fontSize: 18, fontWeight: 600 }}>
        Was sollen wir ändern?
      </div>
      <div
        style={{
          fontSize: 12,
          color: 'var(--ink-mute)',
          marginTop: 4,
          marginBottom: 14,
        }}
      >
        Eine kostenlose Korrekturrunde ist enthalten.
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
        {categories.map((c) => (
          <button
            key={c.id}
            onClick={() => setCategory(c.id)}
            style={{
              padding: '6px 12px',
              borderRadius: 999,
              border: category === c.id ? '1.5px solid var(--terracotta)' : '1px solid var(--line)',
              background: category === c.id ? 'var(--bg)' : 'transparent',
              fontSize: 12,
              fontWeight: 600,
              color: category === c.id ? 'var(--terracotta-deep)' : 'var(--ink-soft)',
              cursor: 'pointer',
            }}
          >
            {c.label}
          </button>
        ))}
      </div>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Beschreibe kurz, was geändert werden soll …"
        style={{
          width: '100%',
          minHeight: 90,
          padding: 12,
          background: 'var(--bg)',
          border: '1px solid var(--line)',
          borderRadius: 10,
          fontSize: 13,
          color: 'var(--ink)',
          fontFamily: 'var(--sans)',
          resize: 'vertical',
          boxSizing: 'border-box',
          outline: 'none',
        }}
      />
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <Button variant="primary" size="sm" disabled={message.trim().length === 0}>
          Korrektur senden
        </Button>
        <button
          onClick={onCancel}
          style={{
            background: 'transparent',
            border: 0,
            color: 'var(--ink-mute)',
            cursor: 'pointer',
            fontSize: 13,
          }}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}
